/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable } from 'inversify'
import { action, computed, observable } from 'mobx'
import { isEmpty } from 'validator'
import { injectProperty } from '../../configuration/ServiceLocator'
import { ValidationResult } from '../../utils/ValidationResult/ValidationResult'
import { IProductsState } from '../../views/Product/Product'
import IProductsApiClient from '../ProductsApiClient/contracts'
import { IProducts, IProductStateManager, ISection } from './contracts'

@injectable()
export class ProductStateManager implements IProductStateManager {
	@observable
	products: IProducts[] =
		[{ productName: '', productCode: '', sectionList: [{ sectionName: '', sectionId: '' } as ISection] } as IProducts]

	@observable
	selectedProduct: string

	@observable
	selectedProductName: string

	@observable
	selectedType: string

	@observable
	selectedSection: string

	@observable
	selectedArticle: string

	@observable
	searchTerm: string

	@injectProperty('IProductsApiClient')
	public productsApiClient!: IProductsApiClient

	constructor () {
		this.products = [{ productName: '', productCode: '', sectionList: [{ sectionName: '', sectionId: '' } as ISection] } as IProducts]
		this.selectedProduct = ''
		this.selectedType = ''
		this.selectedSection = ''
		this.selectedArticle = ''
		this.searchTerm = ''
		this.selectedProductName = ''
	}

	@action setProducts(products: IProducts[]) {
		this.products = products
		//this.selectedProduct = this.products.length > 0 ? this.products[0].productCode : ''
	}

	@action getProductsfromJwt(JwtToken: string): Promise<void> {
		return this.productsApiClient
			.getProductsfromJwt(JwtToken)
			.then(response => this.setProducts(response))
			.catch(error => {
				console.log(error)
				throw new Error('an error occurred when fetching the products')
			})
	}

	@action setSelectedProduct(productCode: string, productName: string) {
		this.selectedProduct = productCode
		this.selectedProductName = productName
	}

	@action setSelectedType(type: string) {
		this.selectedType = type
	}


	@action setSelectedSection(sectionId: string) {
		this.selectedSection = sectionId
	}

	@action setSelectedArticle(contenItemId: string) {
		this.selectedArticle = contenItemId
	}

	@computed get validateSearchTerm(): ValidationResult {
		const result = new ValidationResult()
		if (isEmpty(this.searchTerm)) {
			result.setMessage('searchTerm', 'Search field is required.')
		}
		return result
	}

	@action setSearchTerm(searchTerm: string): void {
		this.searchTerm = searchTerm
	}
}
